module.exports = __webpack_public_path__ + "img/qr_rectangle_03.png";